import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Heders from "../components/Headers";
import Banner from "../components/Banner";
import Categorys from "../components/Categorys";
import FeatureProducts from "../components/products/FeatureProducts";
import Products from "../components/products/Products";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { get_category, get_products } from "../store/reducers/homeReducer";

const Home = ({ sellerId, sellerName }) => {
  const dispatch = useDispatch();
  const { products, latest_product, topRated_product, discount_product } = useSelector((state) => state.home);
  const { userInfo } = useSelector((state) => state.auth);
  useEffect(() => {
    document.title = "4POS eCommerce Customer";
  }, []);
  useEffect(() => {
    if (!sellerId) {
      return;
    }
    dispatch(get_products(sellerId));
    dispatch(get_category(sellerId));
  }, [dispatch, sellerId]);
  if (!sellerName) {
    console.warn('Home: sellerName is undefined');
    return null;
  }

  // Debug sellerId
  // console.log("Home Component - sellerId:", sellerId);

  return (
    <div className="w-full">
      <SEO
        title={`${sellerName} - Online Store | 4POS eCommerce`}
        description={`Shop at ${sellerName} - Discover amazing products, latest trends, and great deals. Fast shipping and secure checkout.`}
        keywords={`${sellerName}, online shopping, ecommerce, products, deals, ${sellerName} store`}
        url={window.location.href}
        type="website"
        organization={{
          name: sellerName,
          url: window.location.origin,
          description: `${sellerName} - Your trusted online store`
        }}
      />
      <Heders sellerId={sellerId} sellerName={sellerName} />
      <Banner sellerId={sellerId} sellerName={sellerName} />
      <div className="my-4">
        <Categorys sellerId={sellerId} sellerName={sellerName} />
      </div>
      <div className="py-[45px]">
        <FeatureProducts products={products} sellerId={sellerId} sellerName={sellerName} />
        <div className="w-full flex justify-center mt-8">
          <Link
            to={`/${sellerName}/products`}
            className="bg-indigo-600 text-white px-8 py-3 rounded-lg hover:bg-indigo-700 transition-colors duration-200 font-medium text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200"
          >
            View All Products
          </Link>
        </div>
      </div>
      {/* <div className="py-10">
        <div className="w-[85%] flex flex-wrap mx-auto">
          <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
            <div className="overflow-hidden">
              <Products
                title="Latest Product"
                products={latest_product}
                sellerId={sellerId}
              />
            </div>
            <div className="overflow-hidden">
              <Products
                title="Top Rated Product"
                products={topRated_product}
                sellerId={sellerId}
              />
            </div>
            <div className="overflow-hidden">
              <Products
                title="Discount Product"
                products={discount_product}
                sellerId={sellerId}
              />
            </div>
          </div>
        </div>
      </div> */}
      <Footer sellerId={sellerId} sellerName={sellerName} />
    </div>
  );
};

export default Home;
